import React, { useState, useEffect } from 'react';
import './Store.css';
import { useNavigate } from 'react-router-dom';
import { 
  FaStore, 
  FaRocket, 
  FaShieldAlt, 
  FaBolt, 
  FaGift, 
  FaUsers, 
  FaCheck,
  FaArrowRight,
  FaPlay
} from 'react-icons/fa';
import logo from '../assets/logo.png';
import NavBar from './NavBar';



const Store = () => {
  // Navegación
  const navigate = useNavigate();
    const navigateToRegisterUser = () => {
        navigate('/register-user');
    };

        const navigateToLoginUser = () => {
        navigate('/login-user');
    };

  const [animatedNumbers, setAnimatedNumbers] = useState({
    users: 0,
    services: 0,
    satisfaction: 0
  });


  const features = [
    {
      icon: <FaStore />,
      title: "Compra Directa",
      description: "Suscripciones, recargas y servicios digitales al alcance de un clic. Sin intermediarios.",
      color: "#007bff"
    },
    {
      icon: <FaBolt />,
      title: "Entrega Inmediata",
      description: "Recibe tus servicios en segundos. Nuestro sistema automatizado es el más rápido.",
      color: "#ffd700"
    },
    {
      icon: <FaShieldAlt />,
      title: "100% Seguro",
      description: "Protección total en tus compras. Garantía de reembolso y soporte 24/7.",
      color: "#28a745"
    },
    {
      icon: <FaGift />,
      title: "Ofertas Exclusivas",
      description: "Accede a descuentos y promociones que solo nuestros miembros pueden disfrutar.",
      color: "#dc3545"
    }
  ];

  const benefits = [
    "Acceso a más de 35 servicios premium",
    "Ahorro garantizado en tus compras",
    "Historial completo de compras",
    "Compra al instante con un clic",
    "Sin intermediarios",
    "Acceso a ofertas exclusivas",
  ];

  // Animación de números
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimatedNumbers(prev => ({
        users: prev.users < 800 ? prev.users + 22 : 800,
        services: prev.services < 35 ? prev.services + 1 : 35,
        satisfaction: prev.satisfaction < 98 ? prev.satisfaction + 1 : 98
      }));
    }, 50);

    return () => clearInterval(interval);
  }, []);


  return (
    <>
    <NavBar />
    <div className="store-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background"></div>
        <div className="hero-content">
          <div className="logo-container">
            <div className="logo-icon">🐻</div>
            <img src={logo} alt="Logo de BearMax" className="company-logo" style={{ maxWidth: '180px' }} />
            <span className="brand-subtitle">Premium Access</span>
          </div>
          
          <h2 className="hero-title">
            Vive el entretenimiento <br />
            <span className="gradient-text"> Sin Límites</span>
          </h2>
          
          <p className="hero-description">
          Accede a tus servicios de streaming favoritos en un solo lugar, con precios irresistibles,
           máxima calidad y garantía total.

          </p>

          <div className="cta-section">
            <button className="cta-primary" onClick={navigateToRegisterUser}>
              <span>Registrarse Gratis</span>
              <FaArrowRight />
            </button>
            <button className="cta-secondary" onClick={navigateToLoginUser}>
              <FaPlay />
              <span>Iniciar Sesión</span>
            </button>
          </div>

          {/* Stats */}
          <div className="stats-container">
            <div className="stat-item">
              <div className="stat-number">{animatedNumbers.users.toLocaleString()}+</div>
              <div className="stat-label">Usuarios</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{animatedNumbers.services}+</div>
              <div className="stat-label">Servicios Disponibles</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{animatedNumbers.satisfaction}%</div>
              <div className="stat-label">Satisfacción</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="section-header">
          <h3>¿Por qué elegirnos?</h3>
          <p>Descubre todas las ventajas que tenemos para ti</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card" style={{'--accent-color': feature.color}}>
              <div className="feature-icon" style={{backgroundColor: feature.color}}>
                {feature.icon}
              </div>
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="benefits-content">
          <div className="benefits-text">
            <h3>Beneficios exclusivos al registrarte</h3>
            <p>Al registrarte en Bearmax, desbloqueas un mundo de posibilidades:</p>
            
            <div className="benefits-list">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item">
                  <FaCheck className="check-icon" />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <button className="benefits-cta" onClick={navigateToRegisterUser}>
              Quiero estos beneficios
              <FaRocket />
            </button>
          </div>

          <div className="benefits-visual">
            <img
              src="/img/gojo.gif"
              alt="Gojo bailando"
              style={{
                display: 'block',
                margin: '0 auto',
                maxWidth: '300px',
                width: '100%',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
              }}
            />
          </div>

        </div>
      </section>

     i {/* Questions Section */}
    <section className="faq-section">
      <div className="section-header">
        <h3>Preguntas Frecuentes</h3>
        <p>¿Tienes dudas? Aquí resolvemos las más comunes.</p>
      </div>

        <div className="faq-list" style={{ maxWidth: '800px', margin: '0 auto' }}>



          <div className="faq-item">
            <h4>¿Cómo compro un servicio?</h4>
            <p>Solo necesitas registrarte, seleccionar el servicio deseado y realizar el pago. La activación se realiza de forma automática.</p>
          </div>

          <div className="faq-item">
            <h4>¿Qué métodos de pago aceptan?</h4>
            <p>Aceptamos pagos mediante Bre-B y QR Redeban para otras entidades en Colombia. Si te encuentras en otro país, puedes pagar a través de Binance Pay</p>
          </div>

          <div className="faq-item">
            <h4>¿Los pagos son seguros?</h4>
            <p>Sí, todos los pagos están protegidos por la entidad bancaria correspondiente y respaldados por el valor total de la transacción.</p>
          </div>

        <div className="faq-item">
          <h4>¿Quieres ser revendedor?</h4>
          <p>Regístrate en nuestro sitio web y contáctanos por WhatsApp para activar precios especiales exclusivos. ¡Empieza a vender y maximiza tus ganancias hoy mismo!</p>
        </div>

          <div className="faq-item">
            <h4>¿Cómo recibo los datos de acceso al servicio?</h4>
            <p>Una vez confirmado el pago de forma automática, recibirás tus credenciales de acceso al instante. Además, se guardarán en tu historial de compras para futuras consultas.</p>
          </div>
        </div>


 
    </section>


      {/* CTA Final Section */}
      <section className="final-cta-section">
        <div className="cta-content">
          <h3>¿Listo para empezar?</h3>
          <p>Únete a la revolución digital. Es gratis, rápido y sin compromisos.</p>
          
          <div className="final-cta-buttons">
        <button
          className="cta-primary large"
          onClick={navigateToRegisterUser}
          style={{ display: 'block', margin: '0 auto' }}
        >
          Crear mi cuenta gratis 
          <FaArrowRight />
        </button>

          </div>

          <div className="trust-indicators">
            <div className="trust-item">
              <FaShieldAlt />
              <span>Pagos Seguros</span>
            </div>
            <div className="trust-item">
              <FaBolt />
              <span>Entrega Inmediata</span>
            </div>
            <div className="trust-item">
              <FaUsers />
              <span>Garantía</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} BearMax - Todos los derechos reservados</p>
        <p>Tu plataforma de confianza para servicios digitales premium</p>
      </footer>
    </div>
    </>
  );
};

export default Store;